// src/components/PrivateRoute.js
import React, { useContext, useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../../providers/AuthContext';
import Loader from './Loader';

const PrivateRoute = ({ isAuthenticated }) => {
  const { token, setIsAdminAuthenticated } = useContext(AuthContext);
  const [verified, setVerified] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!isAuthenticated || !token) {
      setChecking(false);
      setVerified(false);
      return;
    }

    let cancelled = false;
    const verify = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/verify`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!cancelled) {
          if (response.ok) {
            setVerified(true);
          } else {
            setIsAdminAuthenticated(false);
            setVerified(false);
          }
        }
      } catch {
        if (!cancelled) {
          setIsAdminAuthenticated(false);
          setVerified(false);
        }
      } finally {
        if (!cancelled) setChecking(false);
      }
    };
    verify();
    return () => { cancelled = true; };
  }, [isAuthenticated, token, setIsAdminAuthenticated]);

  if (checking) return <Loader />;
  return verified ? <Outlet /> : <Navigate to="/admin" />;
};

export default PrivateRoute;
